export enum NOTIFICATION_TYPES {
	'BidInviteCommand' = 'BidInviteCommand',
	'LoadPostedCommand' = 'LoadPostedCommand',
	'BrokerBidCounterCommand' = 'BrokerBidCounterCommand',
	'BookingConfirmedCarrierCommand' = 'BookingConfirmedCarrierCommand',
	'BidAcceptCommand' = 'BidAcceptCommand',
	'BookingConfirmationEmailCommand' = 'BookingConfirmationEmailCommand',
	'BidCounterEmailCommand' = 'BidCounterEmailCommand',
	'BookingSignatureEmailCommand' = 'BookingSignatureEmailCommand',
	'ProjectRateReceivedEmailCommand' = 'ProjectRateReceivedEmailCommand',
	'TaskAssignedEmailCommand' = 'TaskAssignedEmailCommand',
	'ProjectBestRateUpdatedCommand' = 'ProjectBestRateUpdatedCommand',
	'CalculateProbabilityCommand' = 'CalculateProbabilityCommand',
	'CarrierOpenedEmail' = 'CarrierOpenedEmail',
	'CarrierNotAvailableRFPCommand' = 'CarrierNotAvailableRFPCommand',
	'ProjectOwnerEmailCommand' = 'ProjectOwnerEmailCommand',
	'UserCarrierMapAssignedEmailCommand' = 'UserCarrierMapAssignedEmailCommand',
	'CheckProjectCommand' = 'CheckProjectCommand',
	'DownloadCarriersEmailCommand' = 'DownloadCarriersEmailCommand',
	'CarrierExcludedEmailCommand' = 'CarrierExcludedEmailCommand',
	'LoadFileReceivedCommand' = 'LoadFileReceivedCommand',
}

export enum DISPLAY_STATUSES {
	'9bcd4613-831e-4cb4-a76f-9166ce559fa6' = 'Active',
	'adc9769e-d2d7-4931-b373-f0221dcef6c2' = 'Confirmed',
	'9a0dc3e6-b451-4cf0-92e5-29d6e3695102' = 'Accepted',
	'd2261f74-2f48-4c01-a426-748ecb950912' = 'Countered',
	'269e4734-6ade-44a3-952b-6e619d0ac14b' = 'Declined',
	'47102931-c5cd-4732-bb75-00e73c702e9e' = 'Invited',
	'cb556a7e-8a46-4d08-850a-f2fa44e66673' = 'Viewed',
}

export const NOTIFICATION_MESSAGE = {
	BidInviteCommand: {
		title: 'Matching Load Found',
		alertContent: 'Open the C4 Extension for details',
	},
	LoadPostedCommand: {
		title: 'New Load Posted',
		alertContent: 'Open the C4 Extension for details.',
	},
	BrokerBidCounterCommand: {
		title: 'Counter offer Recieved.',
		alertContent: 'Open the C4 Extension for details.',
	},
	BookingConfirmedCarrierCommand: {
		title: 'Booking confirmed.',
		alertContent: 'Open the C4 Extension for details.',
	},
	BidAcceptCommand: {
		title: 'Bid Accepted.',
		alertContent: 'Open the C4 Extension for details.',
	},
	BookingConfirmationEmailCommand: {
		title: 'Booking confirmed',
		alertContent: 'Open the C4 Extension for details.',
	},
	BidCounterEmailCommand: {
		title: 'Offer countered.',
		alertContent: 'Open the C4 Extension for details.',
	},
	BookingSignatureEmailCommand: {
		title: 'Signed booking contract.',
		alertContent: 'Open the C4 Extension for details.',
	},
	ProjectRateReceivedEmailCommand: {
		title: 'Project Rate Received.',
		alertContent: 'Open for details.',
	},
	TaskAssignedEmailCommand: {
		title: 'New task assigned to you.',
		alertContent: 'Open for details.',
	},
	CarrierNotAvailableRFPCommand: {
		title: 'Carrier does not have any trucks for your request.',
		alertContent: 'Open for details.',
	},
	DownloadCarriersEmailCommand: {
		title: 'Your csv download is mailed to you',
		alertContent: 'Open for details.',
	},
	CarrierExcludedEmailCommand: {
		title: 'Carrier excluded',
		alertContent: 'Open for details.',
	},
};
